import { useDispatch } from "react-redux";
import useCurrentLocation from "./useCurrentLocation";
import { qrSetFrames } from "../redux/slices/qrFrames";
import { qrSetSettings } from "../redux/slices/qrSettings";
import { qrSetText } from "../redux/slices/qrTextSettings";
import { setQrOptions } from "../redux/slices/qrOptions";
import useFrames from "./useFrames";

export default function useLocalStorageQrConfigs() {
  const { urlParam } = useCurrentLocation();
  const dispatch = useDispatch();
  const { frameConfigs } = useFrames();

  const getLocalConfigs = () => {
    const iframeQrConfigs = JSON.parse(localStorage.getItem(urlParam));
    if (iframeQrConfigs) {
      const frame = frameConfigs.find(
        (item) => item.name === iframeQrConfigs?.qrFrames?.frame
      );
      const transformParams = {};
      if (frame) {
        transformParams.frameTransform = frame.transformQr;
        transformParams.transformFrameText = frame.transformFrameText;
      }
      dispatch(
        qrSetFrames({ ...iframeQrConfigs.qrFrames, ...transformParams })
      );
      dispatch(qrSetSettings(iframeQrConfigs.qrSettings));
      dispatch(qrSetText(iframeQrConfigs.qrText));
      dispatch(setQrOptions(iframeQrConfigs.qrOptions));
    }
  };

  const setLocalConfigs = (qrProperties) => {
    const propsToSave = {
      ...qrProperties,
      qrSettings: { ...qrProperties.qrSettings, logotype: null },
    };
    localStorage.setItem(urlParam, JSON.stringify(propsToSave));
  };

  return {
    getLocalConfigs,
    setLocalConfigs,
  };
}
